import { FC } from 'react';

import { Bottom } from './Bottom/Bottom';
import { Middle } from './Middle/Middle';
import { Style } from './style';
import { Top } from './Top/Top';

type DashboardProps = {
  logo: any,
  plantId: any,
  isEng: any,
  temperature: any,
  pvGenerationDay: any,
  pvGenerationTotal: any,
  dateToday: any,
  address: any,
  systemInfo: any,
  peakPower: any,
  graph: any,
  pvPower: any,
  co2: any,
  currency: any
  co2Reduction: any,
  co2ReductionTotal: any,
  totalSavingLife: any,
  totalSavingDay: any,
  power: any,
}

const Dashboard: FC<DashboardProps> = ({
  logo,
  plantId,
  isEng,
  temperature,
  pvGenerationDay,
  pvGenerationTotal,
  dateToday,
  address,
  peakPower,
  systemInfo,
  graph,
  pvPower,
  co2,
  currency,
  co2Reduction,
  co2ReductionTotal,
  totalSavingLife,
  totalSavingDay,
  power,
}) => {

  return (
    <Style>
      <div className='content'>
        <div className='box-content'>
          <div className='flex'>
            {logo}
          </div>
          <Top
            // {...props}
            id={plantId}
            isEng={isEng}
            power={power}
            temperature={temperature}
            pvGenerationDay={pvGenerationDay}
            pvGenerationTotal={pvGenerationTotal}
            dateToday={dateToday}
            address={address}
            systemInfo={systemInfo}
          />
          <Middle peakPower={peakPower} isEng={isEng} graph={graph} pvPower={pvPower} />
          <Bottom
            isEng={isEng}
            co2={co2}
            currency={currency}
            co2Reduction={co2Reduction}
            co2ReductionTotal={co2ReductionTotal}
            pvGenerationDay={pvGenerationDay}
            pvGenerationTotal={pvGenerationTotal}
            totalSavingLife={totalSavingLife}
            totalSavingDay={totalSavingDay}
          />
        </div>
      </div>
    </Style>
  )
}

export default Dashboard